import { ApiDocumentResponseV2, ApiTaskDocumentResponseV2 } from '@/shared/api';
import { useModalsStore } from '@/widgets/modals';

import { useDocuments } from './useDocuments';

type AddFileToTaskParams = {
  caseId: string;
  onSave: (documents: ApiDocumentResponseV2[]) => Promise<void> | void;
  taskAttachments: ApiTaskDocumentResponseV2[];
};

export const useTaskAttachments = () => {
  const modals = useModalsStore();
  const { getDocumentsByCaseId } = useDocuments();

  const openTaskAttachments = ({ caseId, onSave, taskAttachments }: AddFileToTaskParams) => {
    if (!caseId) return;

    const openSelectFiles = () => {
      modals.openModal({
        type: 'SelectDocumentFiles',
        caseId,
        taskAttachments,
        onSave,
      });
    };

    const hasCaseDocuments =
      getDocumentsByCaseId(caseId).filter(
        (doc) => !taskAttachments.some((attachment) => attachment.id === doc.id),
      ).length > 0;

    if (hasCaseDocuments) {
      openSelectFiles();
      return;
    }

    modals.openModal({
      type: 'SelectDocumentsToCaseModal',
      onFinish: openSelectFiles,
      caseId,
    });
  };

  return { openTaskAttachments };
};
